import api from "../api/axios";

export async function getAiReport(agreements) {
  try {
    const response = await api.post("/api/v1/ai_reports", { agreements });
    return response.data.report;
  } catch (error) {
    console.error("Error obteniendo informe IA:", error);
    return null; // fallback
  }
}
